import cookieManager from '../common/cookieManager'
import utils from '../common/utils'

/**
 * 用户会话（H5 业务登录）
 * 小程序 openid/短期 token 只存在小程序本地；H5 登录从 URL 读取，不落盘。
 */
export default {
  state: {
    token: '',
    userimg: '',
    username: '',
    customerName: '',
    userRoles: '',
    themeAside: null
  },
  mutations: {
    setToken(state, val) {
      state.token = val
      const encryptedToken = utils.encryptKey(val)
      cookieManager.set('token', encryptedToken)
    },
    clearToken(state) {
      state.token = ''
      state.equser = []
      state.username = ''
      state.userimg = ''
      state.customerName = ''
      state.userRoles = ''
      cookieManager.remove('token')
      cookieManager.remove('userimg')
      cookieManager.remove('username')
      cookieManager.remove('customerName')
      cookieManager.remove('userRoles')
      // 兼容清理：旧版曾把 mp 凭证写入 cookie
      cookieManager.remove('mpOpenid')
      cookieManager.remove('mpToken')
    },
    getToken(state) {
      const encryptedToken = cookieManager.get('token')
      if (encryptedToken) {
        state.token = utils.decryptKey(encryptedToken)
      }
    },
    setUserimg(state, val) {
      state.userimg = val
      cookieManager.set('userimg', val)
    },
    getUserimg(state) {
      state.userimg = state.userimg || cookieManager.get('userimg')
    },
    setUsername(state, val) {
      state.username = val
      cookieManager.set('username', val)
    },
    getUsername(state) {
      state.username = state.username || cookieManager.get('username')
    },
    setCustomerName(state, val) {
      state.customerName = val != null ? String(val) : ''
      cookieManager.set('customerName', state.customerName)
    },
    getCustomerName(state) {
      state.customerName = state.customerName || cookieManager.get('customerName') || ''
    },
    setUserRoles(state, val) {
      state.userRoles = val != null ? String(val) : ''
      cookieManager.set('userRoles', state.userRoles)
    },
    getUserRoles(state) {
      state.userRoles = state.userRoles || cookieManager.get('userRoles') || ''
    },
    setThemeAside(state, theme) {
      state.themeAside = theme
      try {
        localStorage.setItem('theme.aside', JSON.stringify(theme || {}))
      } catch (e) {}
    }
  }
}
